<template>
  <div class="list-container">
    <div class="list-title" v-show="showTitle">
      <span>{{ showTitle }}</span>
      <span v-show="showSpan" @click="toList(showSpan)">>></span>
    </div>
    <ul :class="isTop ? 'ul-isTop' : 'ul-notTop'" v-if="timeFront">
      <li
        class="list2"
        v-for="(item, i) in newsList"
        :key="i"
        @click="toDeatils(item.id,toSpan)"
      >
        <div class="list2-info">
          <div class="list2-time" v-show="showTime">
            {{ item.publishTime | date-format }}
          </div>
           
          <div class="list2-news">{{ item.title }}</div>
        </div>
                    
      </li>
    </ul>
    <ul :class="isTop ? 'ul-isTop' : 'ul-notTop'" v-else>
      <li
        class="list1"
        v-for="(item, i) in newsList"
        :key="i"
        @click="toDeatils(item.id,toSpan)"
      >
        <span class="list1-news">{{ item.title }}</span>         
        <span class="list1-time" v-show="showTime">{{
          item.publishTime | date-format
        }}</span
        >    
      </li>
    </ul>
    <div class="list-page">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pagesize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        v-show="showPage"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "indexList",
  props: {
    showTitle: String,
    showSpan: String,
    toSpan: String,
    showPage: String,
    showTime: String,
    timeFront: String,
    isTop: String,
    type:Number,
    required: true,
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      total: 20,
      // isTop:'',
      // type: 1,
      newsList: [
        // {
        //   content: "传达学习习近平总书记重要讲话精神 部署新冠肺炎防控…",
        //   time: "2019-08-01",
        // },
        // {
        //   content: "传达学习习近平总书记重要讲话精神 部署新冠肺炎防控…",
        //   time: "2019-08-01",
        // },
        // {
        //   content: "传达学习习近平总书记重要讲话精神 部署新冠肺炎防控…",
        //   time: "2019-08-01",
        // },
      ],
    };
  },
  created() {
    this.getList();
  },
  methods: {
    //分页
    async handleCurrentChange(val) {
      //当前页变化检测
      this.currentPage = val;
      let params = {
        type: this.type,
        page: val,
      };
      try {
        const res = await this.API.plat.pageList(params);
        this.fullscreenLoading = false;
        if (res.success == true) {
          this.newsList = res.entity.content;
          // this.total = res.entity.total;
          // this.currentPage = res.entity.page;
          // this.pageSize = res.size;
        }
      } catch (error) {
        // console.log(error);
      }
    },
    //跳转到详情
    toDeatils(id,toSpan) {
      console.log('====',toSpan,this.$route.name)
      if (id) {
        this.$router.push({
          // path: this.$route.name +"/"+showSpan +"/newDetails",
          path: "/"+toSpan +"/newDetails",
          query: { id: id },
        });
      }
    },
    //跳转到列表
    toList(showSpan) {
      console.log('````````',showSpan)
      this.$router.push({
        path:  showSpan,
      });
    },
    // 分页列表
    async getList() {
      //  获取发布文章列表
      let params = {
        type: this.type,
        // page:1,
        // size:10,
      };
      try {
        const res = await this.API.plat.pageList(params);
        if (res.success == true) {
          this.newsList = res.entity.content;
          this.total = res.entity.total;
          this.currentPage = res.entity.page;
          this.pagesize = res.entity.size;
        }
      } catch (error) {
        // console.log(error);
      }
    },
  },
  computed:{
  },
  watch: {
    type(newValue, oldValue) {
      if(newValue){
        this.type=newValue
        console.log('indexList',newValue)
        this.getList()
      }
        
    },
    deep: true, //true 深度监听
    immediate: true,
  },
};
</script>
<style scoped lang="scss">
.list-container {
  .list-title {
    height: 60px;
    line-height: 60px;
    font-weight: 550;
    font-size: 18px;
    color: #1954ad;
    padding: 0 24px;
    border-bottom: 2px solid #eaeaea;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span:first-child{
      font-weight: 550;
      font-size: 18px;
      color: #1954ad;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    span:last-child{
      cursor: pointer;
      background-image: url("../assets/css/img/arrow-R.svg");
      background-repeat: no-repeat;
      color: transparent;
      background-position: center;
    }
  }
  .ul-isTop {
    padding: 0 20px;
    width: 100%;
    .list1 {
      width: 100%;
      font-size: 14px;
      color: #666;
      // height: auto;
      height: 60px;
      border-bottom: 1px dashed #eaeaea;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      display: flex;
      align-items: center;
      min-height: 60px;
      .list1-news {
        font-size: 14px;
        color: #666;
        flex: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .list1-time {
        text-align: right;
        font-size: 14px;
        color: #888;
        flex: 1;
        padding-right: 5%;
      }
    }
    li:hover {
      .list1-news {
        color: #1954ad !important;
      }
      cursor: pointer;
    }
    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #468ffc;
      vertical-align: middle;
      margin-right: 14px;
    }
    .list1:first-child {
      background: #0e90f2;
      border-bottom: none;
      list-style: none;
      background-image: url("../assets/css/img/isTop.svg");
      background-repeat: no-repeat;
      span {
        color: #fff;
        font-size: 16px;
      }
    }
  }
  .ul-notTop {
    padding: 0 20px;
    width: 100%;
    .list1 {
      width: 100%;
      font-size: 14px;
      color: #666;
      //height: auto;
      height: 45px;
      border-bottom: 1px dashed #eaeaea;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      display: flex;
      align-items: center;
      min-height: 45px;

      .list1-news {
        font-size: 14px;
        color: #333;
        flex: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .list1-time {
        text-align: right;
        font-size: 14px;
        color: #888;
        flex: 1;
        padding-right: 5%;
      }
    }
    .list2 {
      width: 100%;
      font-size: 14px;
      color: #666;
      height: 90px;
      border-bottom: 1px dashed #eaeaea;
      white-space: normal;
      word-break: break-all;
      word-wrap: break-word;
      align-items: center;
      min-height: 60px;
      padding-top: 16px;
      .list2-info {
        position: relative;
        top: -13px;
        left: 18px;
        .list2-news {
          font-size: 14px;
          color: #333;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          line-height: 24px;
          max-height: 48px;
          width: 88%;
        }
        .list2-time {
          font-size: 13px;
          color: #888;
          padding-right: 5%;
          padding-bottom: 5px;
        }
      }
    }
    li:hover {
      .list1-news {
        color: #1954ad !important;
      }
      .list2-news {
        color: #1954ad !important;
      }
      cursor: pointer;
    }
    li:before {
      content: "";
      width: 6px;
      height: 6px;
      display: inline-block;
      border-radius: 50%;
      background: #468ffc;
      vertical-align: middle;
      margin-right: 14px;
    }
  }
  .list-page {
    display: flex;
    justify-content: center;
    margin-top: 50px;
  }
}
</style>
